import React from 'react';
import styled from 'styled-components';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { IconCitat } from '../../../../../static/icons/iconCitat';
import colors from '../../../../../tailwind.colors';

const Shape = styled.div`
  border-radius: 50% 50% 47% 52% / 67% 66% 33% 32%;
  height: 800px;
  width: 1000px;
  margin-top: -200px;
  background-color: ${colors.primary[25]};

  @media (max-width: 768px) {
    height: 450px;
    width: 400px;
    margin-top: -50px;
  }

  @media (min-width: 768px) {
    height: 450px;
    width: 400px;
    margin-top: -80px;
    margin-left: -10px;
  }

  @media (min-width: 1000px) {
    height: 600px;
    width: 550px;
    margin-top: -160px;
    margin-left: -20px;
  }

  @media (min-width: 1100px) {
    height: 650px;
    width: 600px;
    margin-top: -160px;
    margin-left: -20px;
  }

  @media (min-width: 1300px) {
    height: 650px;
    width: 600px;
    margin-top: -140px;
    margin-left: 60px;
  }

  @media (min-width: 1500px) {
    height: 750px;
    width: 800px;
    margin-top: -120px;
    margin-left: 20px;
  }

  @media (min-width: 1550px) {
    height: 750px;
    width: 800px;
    margin-top: -120px;
    margin-left: 40px;
  }

  @media (min-width: 1600px) {
    height: 750px;
    width: 800px;
    margin-top: -120px;
    margin-left: 70px;
  }
`;

const DigitalTools = ({ section }) => {
  if (!section) return <p>No Digital Services Data Found</p>;

  return (
    <Stack className="h-auto mb-20 bg-primary-50">
      <div className="flex flex-1 flex-col items-center md:grid lg:grid xl:grid grid-cols-2 max-w-6xl mx-8 sm:mx-auto sm:pl-8">
        <Stack className="gap-2 md:gap-4 mb-20 md:mb-0 py-5 md:py10 sm:mr-6">
          <Typography
            as="h4"
            textAlign="left"
            fontVariant="h4"
            className="sm:mb-10"
          >
            {section.title}
          </Typography>
          <Typography
            textAlign="left"
            fontVariant="lg"
            className="font-normal !text-customGray-600"
          >
            {section.text1}
          </Typography>
          <Typography
            textAlign="left"
            fontVariant="lg"
            className="font-normal !text-customGray-600"
          >
            {section.text2}
          </Typography>
        </Stack>
        <Shape>
          <div className="w-full h-full flex flex-col px-10 justify-center items-center pt-20 bg-transparent gap-5 min-[1300px]:pr-12 min-[1500px]:pr-20">
            <IconCitat />
            <Typography
              as="h5"
              fontVariant="h5"
              className="!text-primary-700 px-18 max-lg:!text-xl max-2xl:!text-2xl"
            >
              {section.cit1}
            </Typography>
          </div>
        </Shape>
      </div>
    </Stack>
  );
};

export default DigitalTools;
